import type { ReactNode } from 'react';
import * as st from './styles.module.scss';

interface ItemInfoProps {
  title: string;
  value?: ReactNode;
  className?: string;
  description?: string;
}

export const ItemInfo: React.FC<ItemInfoProps> = ({ title, value, className, description }) => {
  const hasValue = value || value === 0;
  return (
    <li className={st.item}>
      <span className={st.item__title} title={description ?? ''}>
        {title}
      </span>
      {hasValue && (
        <div className={`${hasValue ? st.item__value : st.item__empty} ${className || ''}`}>
          {value}
        </div>
      )}
    </li>
  );
};
